import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { CustHealth_detail } from "../../Redux/actions/NumHealth";
import { Form, Radio, Button } from "antd/lib";
import GreenTick from "../../assets/icons/green-tick-trans-bg.png";

export default function FloaterMake({ setCurrent, current }) {
  console.log(current);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const CusDeatail = useSelector((state) => state?.healthdetail?.cusInfo);
  const [Loading, setLoading] = useState(false);
  const [gvalue, setValue] = useState(CusDeatail?.planType ? CusDeatail?.planType : "FLOATER");

  const onChange = (e) => {
    console.log(e.target.value);
    const PTvalue = e.target.value;
    form.setFieldsValue({ PTvalue });
    setValue(PTvalue);
  };

  const OnFinish = (values) => {
    console.log(values);
    const UpdateCus = {
      ...CusDeatail,
      planType: values?.plan,
    };
    console.log(UpdateCus);
    dispatch(CustHealth_detail(UpdateCus));
    setCurrent(current + 1);
  };
  console.log('gvalue',gvalue)
  return (
    <>
      <div className="step-container-health d-flex justify-content-center">
        <Form
          layout="vertical"
          form={form}
          style={{ width: "95%" }}
          requiredMark={false}
          onFinish={OnFinish}
        >
          <div className="health-gender-pType">
            <Form.Item
              name="plan"
              style={{ width: "100%" }}
              initialValue="FLOATER"
            >
              <Radio.Group
                className="health-gender-pType"
                onChange={onChange}
                value={gvalue}
              >
                <Radio.Button
                  value="FLOATER"
                  className={gvalue === "FLOATER" && `active-plan-type`}
                >
                  <span>
                    Family Floater{" "}
                    {gvalue === "FLOATER" && (
                      <img src={GreenTick} className="health-ptype-img" />
                    )}
                  </span>
                </Radio.Button>
                <Radio.Button
                  value="NONFLOATER"
                  className={
                    gvalue === "NONFLOATER" && `active-plan-type`
                  }
                >
                  <span>
                    Multi Individual{" "}
                    {gvalue === "NONFLOATER" && (
                      <img src={GreenTick} className="health-ptype-img" />
                    )}
                  </span>
                </Radio.Button>
              </Radio.Group>
            </Form.Item>
          </div>
          <Form.Item>
            <div className="step-btn-health">
              {current && current > 1 ? (
                <Button
                  style={{ width: "40%" }}
                  onClick={() => setCurrent(current - 1)}
                >
                  Back
                </Button>
              ) : null}
              <Button
                loading={Loading}
                type="primary"
                htmlType="submit"
                style={{ width: "40%" }}
              >
                Continue
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </>
  );
}
